import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { PartnershipApplicationForm } from 'store/application/type';
import { AxiosResponse } from 'axios';
import { PostPartnerShipAPI } from 'api/application';
import { GetTermsAPI } from 'api/site';
import { siteActions } from 'store/site';
import Modal from 'components/common/Modal';
import ModalTerms from 'components/Popup/ModalTerms';
import { getAPIErrorMessage } from 'utils';
import {
  CORRECT_PHONE_MSG,
  EMAIL_UNMATCH_MSG,
  RequiredMessage,
} from 'constants/message';
import { isEmail, isPhone } from 'constants/reg';

interface IProps {
  closeModal: () => void;
}

const ModalPartnership: React.FC<IProps> = ({ closeModal }) => {
  const dispatch = useDispatch();
  const {
    openModal: openTermsModal,
    ModalPortal: TermsModalPortal,
    closeModal: closeTermsModal,
  } = Modal();

  const openTerms = async () => {
    const response = await GetTermsAPI('inquiry');
    if (!response?.data) return;
    dispatch(siteActions.getTerm(response.data));
    openTermsModal();
  };

  // post value
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [content, setContent] = useState('');

  // Help Value
  const [nameHelp, setNameHelp] = useState('');
  const [phoneHelp, setPhoneHelp] = useState('');
  const [emailHelp, setEmailHelp] = useState('');
  const [cntHelp, setCntHelp] = useState('');

  // onChange
  const onChangeName = (event: React.ChangeEvent<HTMLInputElement>) =>
    setName(event.target.value);
  const onChangePhone = (event: React.ChangeEvent<HTMLInputElement>) =>
    setPhone(event.target.value);
  const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) =>
    setEmail(event.target.value);
  const onChangeContent = (event: React.ChangeEvent<HTMLTextAreaElement>) =>
    setContent(event.target.value);

  // click
  const clickRequest = async () => {
    if (!validate()) return;

    const partnership: PartnershipApplicationForm = {
      name,
      phone_number: phone,
      email,
      content,
    };

    const response: AxiosResponse = await PostPartnerShipAPI(partnership);

    if (response.status >= 400) {
      alert(getAPIErrorMessage(response));
      return;
    }

    window.location.reload();
  };

  // validate
  const validate = () => {
    if (!name.length) {
      document.getElementById('name').focus();
      setNameHelp(RequiredMessage('이름'));
      return false;
    }

    setNameHelp('');

    if (!phone.length) {
      document.getElementById('tell').focus();
      setPhoneHelp(RequiredMessage('연락처'));
      return false;
    }

    setPhoneHelp('');

    if (!email.length) {
      document.getElementById('eMail').focus();
      setEmailHelp(RequiredMessage('이메일'));
      return false;
    }

    setEmailHelp('');

    if (!content.length) {
      document.getElementById('cnts').focus();
      setCntHelp(RequiredMessage('내용'));
      return false;
    }

    setCntHelp('');

    if (!isPhone(phone)) {
      document.getElementById('tell').focus();
      setPhoneHelp(CORRECT_PHONE_MSG);
      return false;
    }

    setPhoneHelp('');

    if (!isEmail(email)) {
      document.getElementById('eMail').focus();
      setEmailHelp(EMAIL_UNMATCH_MSG);
      return false;
    }

    setEmailHelp('');

    return true;
  };
  return (
    <>
    <div className="dimd-layer">
      <div className="inner sz-type">
        <section className="invite-w">
          <h1>파트너십 문의</h1>
          <div className="form-w">
            <label htmlFor="name">
              이름
              <i className="ness">
                <span>필수입력</span>
              </i>
            </label>
            <input
              type="text"
              id="name"
              placeholder="이름을 입력해주세요"
              title="이름을 입력해주세요"
              value={name}
              onChange={onChangeName}
            />
            {nameHelp !== '' ? <p className="err">{nameHelp}</p> : null}
            <label htmlFor="tell">
              연락처
              <i className="ness">
                <span>필수입력</span>
              </i>
            </label>
            <input
              type="text"
              id="tell"
              placeholder="000-0000-0000"
              title="000-0000-0000"
              value={phone}
              onChange={onChangePhone}
            />
            {phoneHelp !== '' ? <p className="err">{phoneHelp}</p> : null}
            <label htmlFor="eMail">
              이메일
              <i className="ness">
                <span>필수입력</span>
              </i>
            </label>
            <input
              type="text"
              id="eMail"
              placeholder="mail@mail.com"
              value={email}
              onChange={onChangeEmail}
            />
            {emailHelp !== '' ? <p className="err">{emailHelp}</p> : null}
            <label htmlFor="cnts">
              내용
              <i className="ness">
                <span>필수입력</span>
              </i>
            </label>
            <textarea
              id="cnts"
              placeholder="내용을 입력해주세요"
              value={content}
              onChange={onChangeContent}
            />
            {cntHelp !== '' ? <p className="err">{cntHelp}</p> : null}
          </div>
          <div className="agree-box">
            <p>
              <span>
                [필수 안내] 문의 및 상담 개인정보 수집·이용{' '}
                <a onClick={openTerms} style={{ cursor: 'pointer' }}>
                  보기
                </a>
              </span>
            </p>
          </div>
          <div className="ly-btn">
            <a onClick={clickRequest} style={{ cursor: 'pointer' }}>
              문의하기
            </a>
          </div>
          <button type="button" className="btn-close" onClick={closeModal}>
            <span>팝업 닫기</span>
          </button>
        </section>
      </div>
    </div>
    <TermsModalPortal>
      <ModalTerms closeModal={closeTermsModal} />
    </TermsModalPortal>
    </>
  );
};

export default ModalPartnership;
